export const CabinetArrowRightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height={14}
    viewBox="0 0 40 14"
    width={40}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M30.024 13.4a39.811 39.811 0 0 1 1.624-3.136c.56-.896 1.101-1.643 1.624-2.24H.624V5.672h32.648a21.838 21.838 0 0 1-1.624-2.296 45.394 45.394 0 0 1-1.624-3.08h1.96c2.352 2.725 4.816 4.741 7.392 6.048v1.008c-2.576 1.27-5.04 3.285-7.392 6.048h-1.96Z"
      fill="currentColor"
    />
  </svg>
);
